import NextLazyImage from "@/components/Core/NextLazyImage";
import { FloatingPortal } from "@floating-ui/react";
import React from "react";
import styled from "styled-components";
import { motion } from "motion/react";
import { VideoFrame } from "../types";
import useOnclickOutside from "react-cool-onclickoutside";
import { useHotkeys } from "react-hotkeys-hook";

const FloatingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Lightbox = styled.div`
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex; // Added for centering image if it's smaller than container
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  pointer-events: none;
`;

const LightboxImage = styled(motion.img)`
  display: block;
  max-width: 100%;
  max-height: 100%;
  min-width: 0; // Ensure image can shrink below its intrinsic width if needed
  min-height: 0; // Ensure image can shrink below its intrinsic height if needed
  object-fit: contain;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5); // Optional: add some shadow for depth
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  pointer-events: auto;
`;

export default function TimelineLightbox({
  currentVideo,
  framesPath,
  setDisplayLightbox,
}: {
  currentVideo: VideoFrame;
  framesPath: string;
  setDisplayLightbox: (display: boolean) => void;
}) {
  const ref = useOnclickOutside(() => {
    setDisplayLightbox(false);
  });

  useHotkeys("escape", () => {
    setDisplayLightbox(false);
  });
  return (
    <FloatingPortal>
      <FloatingOverlay>
        <Lightbox>
          <LightboxImage
            ref={ref}
            key={currentVideo.thumbnail} // Key for AnimatePresence to detect change
            src={`${framesPath}/${currentVideo.thumbnail}`}
            alt={""}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }} // Short duration for quick fade
          />
        </Lightbox>
      </FloatingOverlay>
    </FloatingPortal>
  );
}
